import Link from 'next/link';

const navigation = {
  main: [
    { name: 'Features', href: '/#features' },
    { name: 'Pricing', href: '/#pricing' },
    { name: 'Guide', href: '/guide' },
    { name: 'Support', href: '/support' },
    { name: 'Blog', href: '/blog' },
    { name: 'GitHub', href: 'https://github.com/BleedingXiko/GhostHub', external: true },
  ],
  legal: [
    { name: 'Privacy', href: '#' },
    { name: 'Terms', href: '#' },
    { name: 'Contact', href: 'mailto:nicholasrosdahl@yahoo.com' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-dark-900 border-t border-dark-700">
      <div className="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
        {/* Main navigation links */}
        <nav className="flex flex-wrap justify-center gap-x-8 gap-y-2">
          {navigation.main.map((item) => (
            <Link 
              key={item.name} 
              href={item.href} 
              target={item.external ? "_blank" : "_self"}
              rel={item.external ? "noopener noreferrer" : ""}
              className="text-base text-gray-400 hover:text-white"
            >
              {item.name}
            </Link>
          ))}
        </nav>
        
        {/* Social links */}
        <div className="mt-8 flex justify-center space-x-6">
          <a href="https://github.com/BleedingXiko/GhostHub" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
            <span className="sr-only">GitHub</span>
            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fillRule="evenodd"
                d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                clipRule="evenodd"
              />
            </svg>
          </a>
        </div>
        
        {/* Copyright */}
        <p className="mt-8 text-center text-base text-gray-400">
          &copy; {new Date().getFullYear()} GhostHub. All rights reserved.
        </p>
        
        {/* Legal links */}
        <div className="mt-4 flex justify-center space-x-6">
          {navigation.legal.map((item) => (
            <Link key={item.name} href={item.href} className="text-sm text-gray-400 hover:text-white">
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}
